export const generalInfo = {
	title: "GENERAL INFORMATION",
	fields: {
		image: {
			label: "Product image",
			ariaLabel: "Upload product image",
		},
		name: {
			label: "Name",
			placeholder: "Product name",
		},
		productType: {
			label: "Product type",
			placeholder: "Select type",
			loading: "Loading...",
		},
		sku: {
			label: "SKU",
			placeholder: "Enter the SKU",
			tooltip:
				"SKU (Stock Keeping Unit) is a unique code to identify the product. If you don't fill it in, we'll generate one automatically.",
		},
		category: {
			label: "Category",
			placeholder: "Select a category",
			newCategoryWarning: "You will create a new category",
			createOption: "Create",
		},
		menuCategory: {
			label: "Menu category",
			placeholder: "Select a menu category",
			newCategoryWarning: "You will create a new category",
			createOption: "Create",
		},
		preparationTime: {
			label: "Preparation time",
			placeholder: "00 minutes",
			tooltip:
				"Enter the time it takes for the kitchen to prepare this product in minutes",
			unit: "minutes",
		},
		description: {
			label: "Description",
			placeholder: "Write a brief description",
		},
		hasAlcohol: {
			label: "Contains alcohol?",
			tooltip:
				"When activated, it will appear on the menu for customers that it contains alcohol",
			yes: "yes",
			no: "no",
		},
	},
	noCategory: "No category",
	noCategoryFound: "No category found",
};
